export {
  getNativeVdpPayload,
  nativeMyCarsPayload,
  nativeOpdPayload,
  nativeStcPayload,
  nativeSrpPayload,
  nativeTermsPayload
} from './getNativePayloads';
